export const nationalitiesOptions = [
  {
    label: "Afganistán",
    value: "AFG",
  },
  {
    label: "Åland",
    value: "ALA",
  },
  {
    label: "Albania",
    value: "ALB",
  },
  {
    label: "Argelia",
    value: "DZA",
  },
  {
    label: "Samoa Americana",
    value: "ASM",
  },
  {
    label: "Andorra",
    value: "AND",
  },
  {
    label: "Angola",
    value: "AGO",
  },
  {
    label: "Anguilla",
    value: "AIA",
  },
  {
    label: "Antártida",
    value: "ATA",
  },
  {
    label: "Antigua y Barbuda",
    value: "ATG",
  },
  {
    label: "Argentina",
    value: "ARG",
  },
  {
    label: "Armenia",
    value: "ARM",
  },
  {
    label: "Aruba",
    value: "ABW",
  },
  {
    label: "Ascensión Island",
    value: "ASC",
  },
  {
    label: "Australia",
    value: "AUS",
  },
  {
    label: "Austria",
    value: "AUT",
  },
  {
    label: "Azerbaiyán",
    value: "AZE",
  },
  {
    label: "Bahamas",
    value: "BHS",
  },
  {
    label: "Baréin",
    value: "BHR",
  },
  {
    label: "Bangladés",
    value: "BGD",
  },
  {
    label: "Barbados",
    value: "BRB",
  },
  {
    label: "Bielorrusia",
    value: "BLR",
  },
  {
    label: "Bélgica",
    value: "BEL",
  },
  {
    label: "Belice",
    value: "BLZ",
  },
  {
    label: "Benin",
    value: "BEN",
  },
  {
    label: "Bermudas",
    value: "BMU",
  },
  {
    label: "Bután",
    value: "BTN",
  },
  {
    label: "Bolivia",
    value: "BOL",
  },
  {
    label: "Bonaire, San Eustaquio y Saba",
    value: "BES",
  },
  {
    label: "Bosnia y Herzegovina",
    value: "BIH",
  },
  {
    label: "Botsuana",
    value: "BWA",
  },
  {
    label: "Brasil",
    value: "BRA",
  },
  {
    label: "Territorio Británico del Océano Índico",
    value: "IOT",
  },
  {
    label: "Brunéi",
    value: "BRN",
  },
  {
    label: "Bulgaria",
    value: "BGR",
  },
  {
    label: "Burkina Faso",
    value: "BFA",
  },
  {
    label: "Burundi",
    value: "BDI",
  },
  {
    label: "Camboya",
    value: "KHM",
  },
  {
    label: "Camerún",
    value: "CMR",
  },
  {
    label: "Canadá",
    value: "CAN",
  },
  {
    label: "Cabo Verde",
    value: "CPV",
  },
  {
    label: "Islas Caimán",
    value: "CYM",
  },
  {
    label: "República Centroafricana",
    value: "CAF",
  },
  {
    label: "Chad",
    value: "TCD",
  },
  {
    label: "Chile",
    value: "CHL",
  },
  {
    label: "China",
    value: "CHN",
  },
  {
    label: "Isla de Navidad",
    value: "CXR",
  },
  {
    label: "Islas Cocos",
    value: "CCK",
  },
  {
    label: "Colombia",
    value: "COL",
  },
  {
    label: "Comoras",
    value: "COM",
  },
  {
    label: "Congo",
    value: "COG",
  },
  {
    label: "Islas Cook",
    value: "COK",
  },
  {
    label: "Costa Rica",
    value: "CRI",
  },
  {
    label: "Croacia",
    value: "HRV",
  },
  {
    label: "Cuba",
    value: "CUB",
  },
  {
    label: "Curazao",
    value: "CUW",
  },
  {
    label: "Chipre",
    value: "CYP",
  },
  {
    label: "Chequia",
    value: "CZE",
  },
  {
    label: "Costa de Marfil",
    value: "CIV",
  },
  {
    label: "Dinamarca",
    value: "DNK",
  },
  {
    label: "Yibuti",
    value: "DJI",
  },
  {
    label: "Dominica",
    value: "DMA",
  },
  {
    label: "República Dominicana",
    value: "DOM",
  },
  {
    label: "Ecuador",
    value: "ECU",
  },
  {
    label: "Egipto",
    value: "EGY",
  },
  {
    label: "El Salvador",
    value: "SLV",
  },
  {
    label: "Guinea Ecuatorial",
    value: "GNQ",
  },
  {
    label: "Eritrea",
    value: "ERI",
  },
  {
    label: "Estonia",
    value: "EST",
  },
  {
    label: "Suazilandia",
    value: "SWZ",
  },
  {
    label: "Etiopía",
    value: "ETH",
  },
  {
    label: "Islas Malvinas",
    value: "FLK",
  },
  {
    label: "Islas Feroe",
    value: "FRO",
  },
  {
    label: "Fiyi",
    value: "FJI",
  },
  {
    label: "Finlandia",
    value: "FIN",
  },
  {
    label: "Francia",
    value: "FRA",
  },
  {
    label: "Guayana Francesa",
    value: "GUF",
  },
  {
    label: "Polinesia Francesa",
    value: "PYF",
  },
  {
    label: "Territorios Australes Franceses",
    value: "ATF",
  },
  {
    label: "Gabón",
    value: "GAB",
  },
  {
    label: "Gambia",
    value: "GMB",
  },
  {
    label: "Georgia",
    value: "GEO",
  },
  {
    label: "Alemania",
    value: "DEU",
  },
  {
    label: "Ghana",
    value: "GHA",
  },
  {
    label: "Gibraltar",
    value: "GIB",
  },
  {
    label: "Grecia",
    value: "GRC",
  },
  {
    label: "Groenlandia",
    value: "GRL",
  },
  {
    label: "Granada",
    value: "GRD",
  },
  {
    label: "Guadalupe",
    value: "GLP",
  },
  {
    label: "Guam",
    value: "GUM",
  },
  {
    label: "Guatemala",
    value: "GTM",
  },
  {
    label: "Guernsey",
    value: "GGY",
  },
  {
    label: "Guinea",
    value: "GIN",
  },
  {
    label: "Guinea-Bissau",
    value: "GNB",
  },
  {
    label: "Guyana",
    value: "GUY",
  },
  {
    label: "Haití",
    value: "HTI",
  },
  {
    label: "Islas Heard y McDonald",
    value: "HMD",
  },
  {
    label: "Honduras",
    value: "HND",
  },
  {
    label: "Hong Kong",
    value: "HKG",
  },
  {
    label: "Hungría",
    value: "HUN",
  },
  {
    label: "Islandia",
    value: "ISL",
  },
  {
    label: "India",
    value: "IND",
  },
  {
    label: "Indonesia",
    value: "IDN",
  },
  {
    label: "Irán",
    value: "IRN",
  },
  {
    label: "Irak",
    value: "IRQ",
  },
  {
    label: "Irlanda",
    value: "IRL",
  },
  {
    label: "Isla de Man",
    value: "IMN",
  },
  {
    label: "Israel",
    value: "ISR",
  },
  {
    label: "Italia",
    value: "ITA",
  },
  {
    label: "Jamaica",
    value: "JAM",
  },
  {
    label: "Japón",
    value: "JPN",
  },
  {
    label: "Jersey",
    value: "JEY",
  },
  {
    label: "Jordania",
    value: "JOR",
  },
  {
    label: "Kazajistán",
    value: "KAZ",
  },
  {
    label: "Kenia",
    value: "KEN",
  },
  {
    label: "Kiribati",
    value: "KIR",
  },
  {
    label: "Kosovo",
    value: "XKX",
  },
  {
    label: "Kuwait",
    value: "KWT",
  },
  {
    label: "Kirguistán",
    value: "KGZ",
  },
  {
    label: "Laos",
    value: "LAO",
  },
  {
    label: "Letonia",
    value: "LVA",
  },
  {
    label: "Líbano",
    value: "LBN",
  },
  {
    label: "Lesoto",
    value: "LSO",
  },
  {
    label: "Liberia",
    value: "LBR",
  },
  {
    label: "Libia",
    value: "LBY",
  },
  {
    label: "Liechtenstein",
    value: "LIE",
  },
  {
    label: "Lituania",
    value: "LTU",
  },
  {
    label: "Luxemburgo",
    value: "LUX",
  },
  {
    label: "Macao",
    value: "MAC",
  },
  {
    label: "Madagascar",
    value: "MDG",
  },
  {
    label: "Malawi",
    value: "MWI",
  },
  {
    label: "Malasia",
    value: "MYS",
  },
  {
    label: "Maldivas",
    value: "MDV",
  },
  {
    label: "Mali",
    value: "MLI",
  },
  {
    label: "Malta",
    value: "MLT",
  },
  {
    label: "Islas Marshall",
    value: "MHL",
  },
  {
    label: "Martinica",
    value: "MTQ",
  },
  {
    label: "Mauritania",
    value: "MRT",
  },
  {
    label: "Mauricio",
    value: "MUS",
  },
  {
    label: "Mayotte",
    value: "MYT",
  },
  {
    label: "México",
    value: "MEX",
  },
  {
    label: "Micronesia",
    value: "FSM",
  },
  {
    label: "Moldavia",
    value: "MDA",
  },
  {
    label: "Mónaco",
    value: "MCO",
  },
  {
    label: "Mongolia",
    value: "MNG",
  },
  {
    label: "Montenegro",
    value: "MNE",
  },
  {
    label: "Montserrat",
    value: "MSR",
  },
  {
    label: "Marruecos",
    value: "MAR",
  },
  {
    label: "Mozambique",
    value: "MOZ",
  },
  {
    label: "Myanmar",
    value: "MMR",
  },
  {
    label: "Namibia",
    value: "NAM",
  },
  {
    label: "Nauru",
    value: "NRU",
  },
  {
    label: "Nepal",
    value: "NPL",
  },
  {
    label: "Países Bajos",
    value: "NLD",
  },
  {
    label: "Nueva Caledonia",
    value: "NCL",
  },
  {
    label: "Nueva Zelanda",
    value: "NZL",
  },
  {
    label: "Nicaragua",
    value: "NIC",
  },
  {
    label: "Níger",
    value: "NER",
  },
  {
    label: "Nigeria",
    value: "NGA",
  },
  {
    label: "Niue",
    value: "NIU",
  },
  {
    label: "Isla Norfolk",
    value: "NFK",
  },
  {
    label: "Corea del Norte",
    value: "PRK",
  },
  {
    label: "Macedonia del Norte",
    value: "MKD",
  },
  {
    label: "Islas Marianas del Norte",
    value: "MNP",
  },
  {
    label: "Noruega",
    value: "NOR",
  },
  {
    label: "Omán",
    value: "OMN",
  },
  {
    label: "Pakistán",
    value: "PAK",
  },
  {
    label: "Palaos",
    value: "PLW",
  },
  {
    label: "Palestina",
    value: "PSE",
  },
  {
    label: "Panamá",
    value: "PAN",
  },
  {
    label: "Papúa Nueva Guinea",
    value: "PNG",
  },
  {
    label: "Paraguay",
    value: "PRY",
  },
  {
    label: "Perú",
    value: "PER",
  },
  {
    label: "Filipinas",
    value: "PHL",
  },
  {
    label: "Islas Pitcairn",
    value: "PCN",
  },
  {
    label: "Polonia",
    value: "POL",
  },
  {
    label: "Portugal",
    value: "PRT",
  },
  {
    label: "Puerto Rico",
    value: "PRI",
  },
  {
    label: "Catar",
    value: "QAT",
  },
  {
    label: "Rumania",
    value: "ROU",
  },
  {
    label: "Rusia",
    value: "RUS",
  },
  {
    label: "Ruanda",
    value: "RWA",
  },
  {
    label: "Reunión",
    value: "REU",
  },
  {
    label: "San Bartolomé",
    value: "BLM",
  },
  {
    label: "Santa Elena",
    value: "SHN",
  },
  {
    label: "San Cristóbal y Nieves",
    value: "KNA",
  },
  {
    label: "Santa Lucía",
    value: "LCA",
  },
  {
    label: "San Martín",
    value: "MAF",
  },
  {
    label: "San Pedro y Miquelón",
    value: "SPM",
  },
  {
    label: "San Vicente y las Granadinas",
    value: "VCT",
  },
  {
    label: "Samoa",
    value: "WSM",
  },
  {
    label: "San Marino",
    value: "SMR",
  },
  {
    label: "Santo Tomé y Príncipe",
    value: "STP",
  },
  {
    label: "Arabia Saudita",
    value: "SAU",
  },
  {
    label: "Senegal",
    value: "SEN",
  },
  {
    label: "Serbia",
    value: "SRB",
  },
  {
    label: "Seychelles",
    value: "SYC",
  },
  {
    label: "Sierra Leona",
    value: "SLE",
  },
  {
    label: "Singapur",
    value: "SGP",
  },
  {
    label: "Sint Maarten",
    value: "SXM",
  },
  {
    label: "Eslovaquia",
    value: "SVK",
  },
  {
    label: "Eslovenia",
    value: "SVN",
  },
  {
    label: "Islas Salomón",
    value: "SLB",
  },
  {
    label: "Somalia",
    value: "SOM",
  },
  {
    label: "Sudáfrica",
    value: "ZAF",
  },
  {
    label: "Islas Georgias del Sur y Sandwich del Sur",
    value: "SGS",
  },
  {
    label: "Corea del Sur",
    value: "KOR",
  },
  {
    label: "Sudán del Sur",
    value: "SSD",
  },
  {
    label: "España",
    value: "ESP",
  },
  {
    label: "Sri Lanka",
    value: "LKA",
  },
  {
    label: "Sudán",
    value: "SDN",
  },
  {
    label: "Surinam",
    value: "SUR",
  },
  {
    label: "Svalbard y Jan Mayen",
    value: "SJM",
  },
  {
    label: "Suecia",
    value: "SWE",
  },
  {
    label: "Suiza",
    value: "CHE",
  },
  {
    label: "Siria",
    value: "SYR",
  },
  {
    label: "Taiwán",
    value: "TWN",
  },
  {
    label: "Tayikistán",
    value: "TJK",
  },
  {
    label: "Tanzania",
    value: "TZA",
  },
  {
    label: "Tailandia",
    value: "THA",
  },
  {
    label: "Timor-Leste",
    value: "TLS",
  },
  {
    label: "Togo",
    value: "TGO",
  },
  {
    label: "Tokelau",
    value: "TKL",
  },
  {
    label: "Tonga",
    value: "TON",
  },
  {
    label: "Trinidad y Tobago",
    value: "TTO",
  },
  {
    label: "Tristán de Acuña",
    value: "SHN",
  },
  {
    label: "Túnez",
    value: "TUN",
  },
  {
    label: "Turkmenistán",
    value: "TKM",
  },
  {
    label: "Islas Turcas y Caicos",
    value: "TCA",
  },
  {
    label: "Tuvalu",
    value: "TUV",
  },
  {
    label: "Turquía",
    value: "TUR",
  },
  {
    label: "Uganda",
    value: "UGA",
  },
  {
    label: "Ucrania",
    value: "UKR",
  },
  {
    label: "Emiratos Árabes Unidos",
    value: "ARE",
  },
  {
    label: "Reino Unido",
    value: "GBR",
  },
  {
    label: "Estados Unidos",
    value: "USA",
  },
  {
    label: "Uruguay",
    value: "URY",
  },
  {
    label: "Uzbekistán",
    value: "UZB",
  },
  {
    label: "Vanuatu",
    value: "VUT",
  },
  {
    label: "Ciudad del Vaticano",
    value: "VAT",
  },
  {
    label: "Venezuela",
    value: "VEN",
  },
  {
    label: "Vietnam",
    value: "VNM",
  },
  {
    label: "Islas Vírgenes Británicas",
    value: "VGB",
  },
  {
    label: "Islas Vírgenes de los Estados Unidos",
    value: "VIR",
  },
  {
    label: "Wallis y Futuna",
    value: "WLF",
  },
  {
    label: "Sahara Occidental",
    value: "ESH",
  },
  {
    label: "Yemen",
    value: "YEM",
  },
  {
    label: "Zambia",
    value: "ZMB",
  },
  {
    label: "Zimbabue",
    value: "ZWE",
  },
];
